'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _BaseMenuDivider = require('./BaseMenuDivider');

var _BaseMenuDivider2 = _interopRequireDefault(_BaseMenuDivider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BaseMenuDivider2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/BaseMenuDivider/index.js
// module id = 264
// module chunks = 0